import { requestAsync } from 'redux-query';

import endpoints from 'consts/endpoints';

export interface uploadRevenueFileParamsType {
  resultKey?: string;
  successCallback?: Function;
  errorCallback?: Function;
  company_id: string;
  body: FormData;
}

export default ({
  resultKey = 'uploadRevenueFile',
  successCallback,
  errorCallback,
  company_id,
  body,
}: uploadRevenueFileParamsType) =>
  requestAsync({
    url: endpoints.uploadPdsRevenueFileUrl(company_id),
    transform: (response) => ({
      [resultKey]: response,
    }),
    queryKey: endpoints.uploadPdsRevenueFileUrl(company_id),
    body,
    meta: {
      successCallback,
      errorCallback,
      authToken: true,
    },
    options: {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    },
    update: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [resultKey]: (_prevEntities, newEntities) => newEntities,
    },
  });
